import type {
  News,
  Activity,
  Category,
  Employee,
  MeetingAgendaPointTemplate,
  Picture,
} from "@/graphql/generated-types";
import { type IFileState } from "@/interfaces";

export interface MediaHolder {
  image?: Category["image"] | Employee["image"];
  picture?: MeetingAgendaPointTemplate["picture"];
  coverImage?: News["coverImage"] | Activity["coverImage"];
  pictures?: News["pictures"] | Activity["pictures"];
}

const toFileState = (picture: Picture): IFileState => {
  return {
    id: picture.id,
    base64: picture.source,
    blurhash: picture.blurhash,
    name: "",
    type: "image",
    isFavorite: false,
    isDefault: picture.id === "-1",
  };
};

export default (item: MediaHolder): IFileState[] => {
  const result: IFileState[] = [];

  const image = item.coverImage || item.image || item.picture;
  if (image && image.id !== "-1") {
    result.push({
      ...toFileState(image),
      isFavorite: true,
    });
  }

  result.push(
    ...(item.pictures || [])
      .filter((item) => item.id !== "-1")
      .filter((item) => !image || item.id !== image.id)
      .map((picture) => toFileState(picture)),
  );

  return result;
};
